import clsx from 'clsx';
import { Switch, SwitchProps } from '../forms';

export type FilterSwitchProps = SwitchProps & {
  title: string;
  children: any;
  classNames?: {
    title?: string;
    container?: string;
  };
};

export const FilterSwitch = (props: FilterSwitchProps) => {
  const { title, children, classNames, ...rest } = props;
  return (
    <div
      className={clsx(
        'flex justify-between items-center',
        classNames?.container
      )}
    >
      <h3
        className={clsx(
          'hd-md py-5 self-start cursor-pointer',
          classNames?.title
        )}
        onClick={() => props.onChange(!props.checked)}
      >
        {title}
      </h3>
      {children ? (
        <div className="flex">
          <div className="pr-10">
            <div className="text-grey-base">{children}</div>
          </div>

          <div className="ml-auto flex items-center">
            <Switch {...rest} title={title} />
          </div>
        </div>
      ) : (
        <Switch {...rest} title={title} />
      )}
    </div>
  );
};
